import React from "react";
import Dashboard from "../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import PingTrees from "../@Components/Products/PingTrees";

const PingTreesPage: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <PingTrees />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default PingTreesPage;
